export default __webpack_public_path__ + "static/media/marker.60be1644.png";